export default function () {
    return process.env.VUE_APP_CONTACT_NUMBER;
}